import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { ElMessage, ElNotification } from 'element-plus';
import { userStore } from '@/stores/user';
import { getUuid } from '@/utils/tools';
// import mockJson from './mock.json';
import mockJson from './mock';

/** 遍历对象属性和属性值，拼接为字符串 */
function objectDeepValuesExCludePhone(obj) {
  if (Object.prototype.toString.call(obj) !== '[object Object]') {
    return '';
  }
  let str = '';
  for (const item in obj) {
    if (typeof obj[item] === 'object') {
      str += objectDeepValuesExCludePhone(obj[item]);
    } else {
      str += obj[item];
    }
  }
  return str;
}
const workingRequest = {};
let controller;
// 取消前面的请求
const cancelWorkingRequest = reqKey => {
  if (workingRequest[reqKey]) {
    // 取消上次相同url&method的请求
    workingRequest[reqKey].abort();
    delete workingRequest[reqKey];
    controller = null;
  }
};
const instance = axios.create({
  validateStatus(status) {
    switch (status) {
      case 400:
        ElMessage.error('请求出错');
        break;
      case 2001:
        ElMessage.warning({
          message: '授权失败，请重新登录',
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        return false;
      case 403:
        ElMessage.warning({
          message: '拒绝访问',
        });
        break;
      case 404:
        ElMessage.warning({
          message: '请求错误,未找到该资源',
        });
        break;
      case 500:
        ElMessage.warning({
          message: '服务端错误',
        });
        break;
    }
    return status >= 200 && status < 300;
  },
});
// 添加请求拦截器
instance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    if (config.mock && ['dev', 'test'].includes(import.meta.env.VITE_APP_ENV)) {
      config.adapter = customConfig => {
        return new Promise((resolve, reject) => {
          const isMock = mockJson[config.url ?? ''];
          if (isMock) {
            setTimeout(() => {
              resolve({
                data: isMock,
                status: 200,
                statusText: 'ok',
                headers: {},
                config: customConfig,
                request: {},
              });
            }, config.waiting ?? 200);
            return;
          }
          reject(new Error('请检查mock数据'));
        });
      };
    } else {
      config.adapter = ['xhr', 'http', 'fetch'];
    }
    const params = config.data;
    if (config.method == 'post' && !config.data?.args && config.headers['Content-Type'] !== 'multipart/form-data') {
      config.data = {
        args: config.data ?? {},
        header: {
          sysNo: 'emcomp-back-office',
          traceId: getUuid(),
          userMark: 'test',
        },
      };
    }
    if (config.method == 'get') {
      config.params = params;
    }
    config.headers['authorization'] = localStorage.getItem('token');
    if (config.download) {
      config.responseType = 'blob';
    }
    // 处理取消重复请求逻辑
    const { url, method, autoCancelRepeat = true } = config;
    // 默认配置取消重复请求，如不需要可以传参false
    if (autoCancelRepeat) {
      // url和method及入参，作为取消上次请求的key
      // ignoreParams时，忽略参数
      // 是否忽略参数的影响，默认不忽略(即url相同参数不同的请求视为不同请求)
      const requestData = config.ignoreParams ? '' : objectDeepValuesExCludePhone(config.data || config.params);
      const reqKey = `${url}_${method}_${requestData}`;
      // 如果重复请求，取消前面的请求
      cancelWorkingRequest(reqKey);
      controller = new AbortController();
      config.signal = controller.signal;
      workingRequest[reqKey] = controller;
    }
    return config;
  },

  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器即异常处理
instance.interceptors.response.use(
  (response: AxiosResponse) => {
    if (response.config?.download) {
      if (Object.prototype.toString.call(response.data) === '[object Blob]') {
        if (response.headers['content-type']?.indexOf('application/json') > -1) {
          const read = new FileReader();
          read.readAsText(response.data, 'utf-8');
          read.onload = data => {
            const json = JSON.parse(data.currentTarget?.result || '{}');
            ElNotification({
              title: '提示',
              message: json.message || '获取失败',
              type: 'warning',
              dangerouslyUseHTMLString: true,
            });
          };
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject();
        }
        if (response.data) {
          if (response.config.download === 'origin') {
            return response;
          }
          return response.data;
        } else {
          ElNotification({
            title: '提示',
            message: '获取失败',
            type: 'warning',
          });
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject({ message: response.data.message });
        }
      }
    }
    const { success, message, data, code } = response.data;
    if (success) {
      return data;
    }
    if (code === 2001 || code === -2) {
      const userStores = userStore();
      ElNotification({
        title: '提示',
        message: '登录失效,请重新登录!',
        type: 'warning',
      });
      userStores.reset();
      return;
    }
    if (!success) {
      if (message) {
        ElNotification({
          title: '提示',
          message: message,
          type: 'warning',
          dangerouslyUseHTMLString: true,
        });
      }
      return Promise.reject();
    }
    return Promise.reject();
  },
  (err: AxiosError) => {
    if (err && err.response) {
      //
    } else {
      err.message = '连接服务器失败';
    }
    return Promise.reject(err.response);
  }
);
export default instance;
